import { createContext } from 'react'

export const TicketingContext = createContext()